import { SourceSystems } from '@helpers';
import { SignalREventResponse } from './base';

export type SourceSystem = (typeof SourceSystems)[keyof typeof SourceSystems];

export enum SourceSystemValidationErrorCode {
  DOCUMENT_ROOT_FOLDER_ACCESS_FAILURE = 'DocumentRootFolderAccessFailure',
  DOCUMENT_SOURCE_ACCESS_FAILURE = 'DocumentSourceAccessFailure',
  UNEXPECTED_ERROR = 'UnexpectedError',
}

export enum ValidationContextName {
  DOCUMENTS_ROOT_FOLDER = 'DocumentsRootFolder',
  MAPPED_NETWORK_PATH = 'MappedNetworkPath',
}

export interface ValidationWarning {
  errorCode: SourceSystemValidationErrorCode;
  message: string;
  validationContextName: ValidationContextName;
  validationContextValue: string;
  isWarning: boolean;
}

export interface OnConfiguredProductionSourceSystemResponse extends SignalREventResponse {
  databaseConfigurationHasChanged: boolean;
  documentsConfigurationHasChanged: boolean;
  sourceSystemSequenceNumber: number;
  sourceSystemCode: SourceSystem;
  validationWarnings?: ValidationWarning[];
  wholeConfigurationHasRemoved: boolean;
  workerThreadScheduleConfigurationHasChanged: boolean;
}
